import React, { useState, useEffect } from "react"

function LandingPageIntro({  landingIntroTitle, landingIntroSubtitle, landingIntroText }){
  return (
        <section className="landing-page-intro bg-white section-spacing-lg">
            <div className="content-block">
                <div className="text-wrapper">
                    <div className="title-wrapper">
                        {landingIntroTitle &&
                            <h3 className="lp-heading-xl navy-title">
                                {landingIntroTitle}
                            </h3>
                        }
                        {landingIntroSubtitle &&
                            <h3 className="lp-heading-xl blue-title">
                                {landingIntroSubtitle}
                            </h3>
                        }
                    </div>
                    {landingIntroText &&
                        <div className="landing-page-intro__text lp-body-lg forty-spacer" dangerouslySetInnerHTML={{ __html: landingIntroText }}>
                        </div>
                    }
                </div>
            </div>
        </section>
    )
}


export default LandingPageIntro
